<script setup lang="ts">
import type IbexaColorPair from '@@/enums/IbexaColorPair'
import type { RouteLocationGeneric } from 'vue-router'
import DefaultFooter from '@/components/layout/DefaultFooter.vue'

defineProps<{
  isHeaderHidden?: boolean
  isFooterHidden?: boolean
  colorPair?: IbexaColorPair
  // Defines the "back to" button in the header
  backTo?: Partial<RouteLocationGeneric> & { buttonText: string }
}>()
</script>

<template>
  <slot
    v-if="!isHeaderHidden"
    name="header"
  >
    <HeaderDefault :back-to="backTo" />
  </slot>
  <main id="hoved">
    <slot />
  </main>
  <slot
    v-if="!isFooterHidden"
    name="footer"
  >
    <DefaultFooter :class="colorPair" />
  </slot>
</template>
